<template>
    <div style='position:relative;'>
        <!-- <h3 class="title">全部产品</h3>
        <ul class="left_nav">
            <li v-for="item in list" :class="{active: isActive(item),open: isOpen(item)}" :key="item.id">
                <div class="nav_title" @click.self="changeNav(item)">
                    <i class="icon" :style="{background: `url(${item.icon}) no-repeat center`}"></i>
                    {{item.name}}
                    <a class="arrow" @click.self="changeNav(item)"
                        v-show="item.sub && item.sub.length > 0 && item.isShow"></a>
                </div>
                <ul class="sub_list" v-show="item.sub && item.sub.length > 0 && item.isShow">
                    <li v-for="subitem in item.sub" :class="{active: isActive(subitem)}"
                        @click.self="changeNav(subitem)" :key="subitem.id">{{subitem.name}}</li>
                </ul>
            </li>
        </ul> -->
        <div class="pic">
            <div class="main_pic">
                <img :src="mainPic" v-show='mainPic'>
            </div>
            <!-- <ul v-show="picList.length > 1">
                <li v-for="(item,index) in picList" :class="{active: index == picIndex}" :key="index"
                    @mouseenter="picEnter(index)">
                    <img :src="item">
                </li>
            </ul> -->
            <a :href="ProductAddress" v-show="ProductAddress" class="knowSoft" target="_blank">点击了解软件功能</a>
        </div>
        <a class="how_link" @click="howToChoose" style="margin-top: 150px;">wh7/WT8/WT9,我该选哪个软件？</a>
        <div class="qr_code">
            微信公众号<br>文华财经小课堂
        </div>
        <!-- <a class='toWH' href="https://www.wenhua.com.cn" target="_blank">进入文华官网</a> -->
        <div class="loading_box" v-show='loading'>
            <div class="loading">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import icon1 from '@/assets/image/zhuanyetaoli.png'
    import icon2 from '@/assets/image/chengxuhua_icon.png'
    import icon3 from '@/assets/image/myquant_icon.png'
    import icon4 from '@/assets/image/mytrader_icon.png'
    import icon5 from '@/assets/image/dianxin_icon.png'
    import icon6 from '@/assets/image/peixun_icon.png'
    import icon7 from '@/assets/image/qihuo_icon.png'
    import icon8 from '@/assets/image/qita_icon.png'

    import axios from 'axios'
    export default {
        name: 'Leftnav',
        components: {

        },
        data: () => ({
            list: [],
            historyNav: [],
            historyItem: null,
            loading: false,
            picIndex: 0,
        }),
        methods: {
            /**切换左侧导航时的函数(changeNav)
             * params:
             *   item {Object}
             */
            // changeNav(item) {
            //     if (item.sub && item.sub.length > 0 && item.isShow) {
            //         item.open = !item.open
            //     }
            //     if ((!item.sub || item.sub.length == 0 || !item.isShow) && (this.$route.params.id != item.id || item.sub)) {
            //         this.list.forEach(v => {
            //             v.open = null
            //         })
            //         let _id = item.id
            //         if (!item.isShow && item.sub && item.sub.length > 0) {
            //             _id = item.sub[0].id
            //         }
            //         if (this.$route.params.id == _id) return
            //         this.clearVuex()
            //         this.$router.push({
            //             path: '/detail/'+_id
            //         })
            //     }
            //     if (item.isPreview && this.$route.name != 'Preview') {
            //         this.$router.push({path: '/preview'})
            //     }
            // },
            /**查询当前的导航叶子的完整面包屑导航时执行的函数(searchItem)
             * params:
             *    id {string} （当前导航叶子的数据项的id）
             */
            searchItem(id) {
                let self = this
                /**递归查询数据(seekData)
                 * params:
                 *    data {Array} （被查询的数据）
                 *    id {string} (查询的条件标识)
                 *    prevItems {Array} (可选#查询的记录项)
                 * return:
                 *    {
                 *      value:  {Object}（查到的数据项）
                 *      prevs： {Array}（查到结果时，之前被查过的所有数据叶子节点）
                 *    }
                 */
                function seekData(data, id, prevItems = [], lv = 0) {
                    lv++
                    
                    let item = {};

                    for (let i = 0; i < data.length; i++) {
                        if ((data[i].cid == id && data[i].sub.length <= 0) || data[i].id == id && lv > 1) { //如果id相同即代表已经查到，直接把查到的项赋值
                            item.value = data[i]
                            break
                        } else if (data[i].sub && data[i].sub.length > 0) { //如果当前项没查到，检查是否含有下级项，如果有下级项，继续向下递归

                            item = seekData(data[i].sub, id, prevItems, lv)
                            if (item.value) {//如果递归结果中有匹配的项，那么就是查到结果了，把结果的open设置为true展开，并把这个结果push到函数体最开始的历史记录的数组中

                                if (data[i].open == null) {
                                    data[i].open = true
                                }
                                prevItems.push(data[i])
                                break
                            }
                        }
                    }
                    if (!item.value) {//最后判断一下，如果没查到值，那么历史记录清空，最后返回的时候历史记录需要倒序一下
                        prevItems = []
                    }
                    return {
                        value: item.value,
                        prevs: JSON.parse(JSON.stringify(prevItems)).reverse()
                    }
                }

                let subnavData = seekData(this.list, id)
                
                if (subnavData.value) {//开始查询导航项，查到的话，把导航拼装一下提交到vuex,以供内页的面包屑导航使用
                    this.$store.commit('setSubNav', ['软件/产品', ...subnavData.prevs.concat([subnavData.value]) || []])
                } else if (id == 81) {
                    this.$store.commit('setSubNav', ['软件/产品', '行情数据授权'])
                }
            },
            // isActive(item) {
            //     let isgroup = item.sub != undefined
            //     let result =  item.id && this.$store.state.subnav.find(v => {
            //         let _isgroup = v.sub != undefined 
            //         return  v.id == item.id && isgroup == _isgroup
            //     })
            //     return result
            // },
            // isOpen(item) {
            //     if (item.open && item.open != null) {
            //         return true
            //     } else {
            //         return false
            //     }
            // },
            howToChoose() {
                this.$market.openFreame({
                    url: '/#/softIntroduction'
                })
            },
            clearVuex () {//清空vuex的账号验证相关数据
                this.$store.commit('renewbuy/setCrossFlag',false)
                this.$store.commit('renewbuy/setInfo',null)
                this.$store.commit('addbuy/setUserInfo',{
                    user: '',
                    password: '',
                    fetchData: null
                })
                this.$store.commit('addbuy/setPrice',0)
                this.$store.commit('setOtherId','')
            },
            picEnter(index) {
                this.picIndex = index
            },
        },
        computed: {
            picList() {
                return this.$store.getters.getPic
            },
            ProductAddress() {
                return this.$store.getters.getProductAddress
            },
            mainPic() {
                return this.picList[this.picIndex]
            },
            navTxt () {
                if (this.list.length == 0) return ''
                for (let i = 0; i < this.list.length; i++) {
                    let item = this.list[i]
                    if (this.$route.params.id == item.id) {
                        return item.name
                    } else {
                        if (item?.sub.length > 0) {
                            for (let j = 0; j < item.sub.length; j++) {
                                let subItem = item.sub[j]
                                if (subItem.id == this.$route.params.id) {
                                    return item.name
                                }
                            }
                        }
                    }
                }
                return ''
            }
        },
        watch: {
            "$route": {
                handler: function (val) {
                    if (this.list.length <= 0) return
                    let id = val.params.id
                    if (id) {
                        if (id == 132) {
                            this.$store.commit('setSubNav', ['软件/产品', '2025年台历'])
                        } else {
                            this.searchItem(id)
                        }
                    } else if (this.$route.name == 'chooseSeat') {
                        this.$store.commit('setSubNav', ['软件/产品','培训课程/教材','麦语言量化交易编程培训课','选座'])
                    } else {
                        this.$store.commit('setSubNav', [])
                    }
                    if(val.params.id != 27) {
                        this.clearVuex()
                    }
                    

                },
                immediate: true,
                deep: true
            },
            list(val) {
                let id = this.$route.params.id
                if (id) {
                    if (id == 132) {
                        this.$store.commit('setSubNav', ['软件/产品', '2025年台历'])
                    } else {
                        this.searchItem(id)
                    }
                } else {
                    this.$store.commit('setSubNav', [])
                }
            },
            data: {
                handler: function (val) {
                    if (!val) return
                    this.picList = val.pic
                },
                immediate: true,
                deep: true
            },
        },
        mounted() {
            var self = this
            this.loading = true
            //请求导航数据
            var url = this.$route.name != 'Preview' ? "/api/Home/ProductListNavi" : "/Api/ProductListNavi?pid=" + this.$route.query.pid + "&appid=" + this.$route.query.appid
            this.$axios({
                url: url,
                method: "get"
            })
            .then(res => {
                
                self.loading = false
                self.list = res.data.map(v => {
                    let obj = {
                        name: v.categoryName,
                        id: v.id,
                        enCategory: v.enCategory,
                        open: null,
                        icon: v.productImgUrl,
                        isShow: v.isShow,
                        isPreview: this.$route.name == 'Preview' ? true : false
                    }
                    if (v.productList && v.productList.length > 0) {
                        obj.sub = v.productList.map(val => ({
                            name: val.productName,
                            id: val.id
                        }))
                    }
                    return obj
                })
                
                //计算云主机所拥有的分类，并存入vuex
                let cloud = res.data.find(v => v.isYun)
                if (!cloud) return
                let cloudVarity = cloud.ids.map(v => {
                    if (v == 39) {
                        return {
                            id: 39,
                            name: 'Ⅱ型（四核4G内存）'
                        }
                    } else if (v == 78) {
                        return {
                            id: 78,
                            name: 'Ⅲ型（四核8G内存）'
                        }
                    } else if (v == 79) {
                        return {
                            id: 79,
                            name: 'Ⅳ型（八核16G内存）'
                        }
                    }
                })
                this.$store.commit('setYunVarity', cloudVarity)


                //培训课程的所有班级，存入vuex
                let peixun = res.data.find(v=>v.isMai)
                if (!peixun) return
                let peixunVarity = []
                peixun.ids.forEach(v=>{
                    /*if (v==46) {
                        peixunVarity.push({
                            id: 46,
                            name: '麦语言'
                        })
                    } else */if (v == 107) {
                        peixunVarity.push({
                            id: 107,
                            name: '麦语言'
                        })
                    }
                })
                this.$store.commit('setLessonVarity', peixunVarity)
            })
            .catch(err => {
                
                this.$market.alert({content: '服务器错误，请稍后再试。'})
            });
        }
    }
</script>

<style scoped>
.qr_code {
    text-align: center;
    width: 84px;
    height: 114px;
    margin-left: 18px;
    margin-top: 22px;
    color: #666;
    line-height: 18px;
    padding-top: 78px;
    background: url(../assets/image/qr_code.png) no-repeat center top;
}
    .loading_box {
        position: absolute;
        left: -20px;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
        background: rgb(255, 255, 255, 0);
    }

    .loading {
        width: 80px;
        height: 15px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -40px;
        margin-top: -7px;
    }

    .loading span {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 5px;
        border-radius: 50%;
        background: #90c7ee;
        animation: load 1.04s ease infinite;
    }

    .loading span:last-child {
        margin-right: 0px;
    }

    @keyframes load {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .loading span:nth-child(1) {
        animation-delay: 0.13s;
    }

    .loading span:nth-child(2) {
        animation-delay: 0.26s;
    }

    .loading span:nth-child(3) {
        animation-delay: 0.39s;
    }

    .loading span:nth-child(4) {
        animation-delay: 0.52s;
    }

    .loading span:nth-child(5) {
        animation-delay: 0.65s;
    }

    .how_link {
        font-size: 13px;
        color: rgb(102, 103, 107);
        cursor: pointer;
        display: block;
        line-height: 27px;
        height: 27px;
        margin-top: 0px;
        margin-left: -2px;
    }

    .how_link::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 27px;
        height: 27px;
        background: url(../assets/image/why_icon.png) no-repeat center;
    }

    .title {
        margin: 0;
        position: relative;
        z-index: 2;
        font-size: 18px;
        font-family: '黑体';
        color: rgb(49, 50, 52);
        padding-bottom: 10px;
        margin-bottom: 30px;
    }

    .title::after {
        content: '';
        width: 25px;
        position: absolute;
        height: 2px;
        background: rgb(49, 50, 52);
        left: 0;
        bottom: -5px;
    }

    .left_nav {
        width: 256px;
        height: 454px;
        margin: 0;
        padding: 0;
        position: relative;
        z-index: 1;
        top: 0;
    }

    .left_nav>li {
        list-style: none;
        margin: 0;
        padding: 0;
        /* height: 48px; */
        font-size: 14px;
        line-height: 48px;
        cursor: pointer;
        text-align: left;
        box-sizing: border-box;
        position: relative;
        font-weight: bolder;
        color: rgb(46, 48, 47);
        margin-left: -20px;
        box-sizing: border-box;
        width: 100%;
    }

    .left_nav>li .nav_title {
        padding-left: 20px;
    }

    .left_nav>li .icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin-right: 5px;
    }

    .left_nav>li .nav_title:hover {
        background: url(../assets/image/left_hover.png) no-repeat left top;
        color: rgb(40, 96, 189);
    }

    .left_nav>li.active .nav_title {
        background: url(../assets/image/left_hover.png) no-repeat left top;
        color: rgb(40, 96, 189);
        height: auto;
    }

    .left_nav>li .arrow {
        width: 14px;
        height: 14px;
        background: url(../assets//image/arrow.png);
        display: block;
        position: absolute;
        right: 18px;
        top: 18px;
        zoom: 1;
        overflow: hidden;
    }

    .left_nav>li:hover .arrow {
        background: url(../assets/image/arrow_hover.png) center;
    }

    .left_nav>li.active .arrow {
        background: url(../assets/image/arrow_hover.png) center;
    }

    .left_nav>li.open .arrow {
        width: 14px;
        height: 14px;
        background: url(../assets//image/arrow_up.png);
        display: block;
        position: absolute;
        right: 18px;
        top: 18px;
        zoom: 1;
        overflow: hidden;
    }

    .left_nav>li.open:hover .arrow {
        background: url(../assets/image/arrow_over.png) center;
    }

    .left_nav>li.open.active .arrow {
        background: url(../assets/image/arrow_over.png) center;
    }

    .left_nav>li:hover .sub_list {
        display: block;
    }

    .left_nav .sub_list {
        margin: 0;
        padding: 0 2px 0 4px;
        box-sizing: border-box;
        width: 100%;
        height: 0;
        overflow: hidden;
        transition: all 0.3s;

    }

    .left_nav>li.open .sub_list {
        height: auto;
    }

    .left_nav .sub_list>li {
        list-style: none;
        margin: 0;
        padding: 0;
        font-size: 12px;
        color: #575757;
        font-weight: normal;
        padding: 6px 0 6px 27px;
        line-height: 22px;
        text-align: left;
        ;
    }

    .left_nav .sub_list>li:last-child {
        border: 0;
    }

    .left_nav .sub_list>li:hover {
        background-color: rgb(229, 238, 247);
        cursor: pointer;
        color: rgb(40, 96, 189);
    }

    .left_nav .sub_list>li.active {
        background-color: rgb(229, 238, 247);
    }

    .toWH {
        background: url(../assets/image/home.png) left no-repeat;
        padding-left: 20px;
        text-decoration: none;
        color: rgb(64, 139, 254);
        margin-top: 150px;
        display: inline-block;
        margin-left: 5px;
    }
    .pic {
        /* flex: 0 244px; */
        width: 368px;
    }

    .main_pic {
        width: 368px;
        height: 294px;
        margin-bottom: 10px;
    }

    .main_pic img {
        width: 100%;
        height: 100%;
    }

    .pic ul {
        margin: 0;
        padding: 0;
        overflow: hidden;
    }

    .pic ul li {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 94px;
        height: 65px;
        float: left;
        position: relative;
        margin-right: 9px;
        cursor: pointer;
        border: 1px solid transparent;
        box-sizing: border-box;
    }

    .pic ul li.active {
        border: 1px solid #f75956;
    }

    .pic ul li:last-child {
        margin-right: 0;
    }

    .pic ul li img {
        width: 100%;
        height: 100%;
    }

    .knowSoft{
        text-decoration: underline;
        color: #0066FF;
        line-height: 20px;
        font-size: 13px;
    }

</style>